import VouchersBuy from '@/components/VouchersBuy'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		vouchers: [],
		...opts,
		vueComponent: VouchersBuy
	}

	let page = vuewidget(dom, options)
	return page
}
